import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export interface RestorerStats {
    projects: number;
    organisations: number;
    sites: number;
    species: number;
}

/** A service to handle misc restorer functions */
@Injectable({ providedIn: 'root' })
export class SeagrassRestorerService {

    /** The constructor */
    constructor(public http: HttpClient) {}

    /** Get all organisations. */
    public stats(): Promise<RestorerStats> {
        return new Promise<RestorerStats>((resolve, reject) => {
            this.http.get<RestorerStats>("/api/restorer/stats")
                .subscribe({
                    next: (stats) => { resolve(stats); },
                    error: (error) => { reject(error.error); }
                });
        });
    }


    public downloadSitesData(): Promise<Blob> {
        return new Promise<Blob>((resolve, reject) => {
            let filename = "SeagrassRestorer - Restoration Sites.csv";
            this.http.get("/api/restorer/export/sites", { responseType: 'blob' }).subscribe({
                next: (blob) => {
                  const a = document.createElement('a');
                  const url = window.URL.createObjectURL(blob);
                  a.href = url;
                  a.download = filename;
                  a.click();
                  window.URL.revokeObjectURL(url);
                },
                error: (err) => {
                  console.error('Download failed', err);
                }
              });
        });
    }

    public downloadSiteMonitoringData(siteId: number, siteName: string): Promise<Blob> {
        return new Promise<Blob>((resolve, reject) => {
            let filename = `SeagrassRestorer - Restoration Site ${siteName} - Monitoring Data.csv`;
            this.http.get(`/api/restorer/export/sites/${siteId}`, { responseType: 'blob' }).subscribe({
                next: (blob) => {
                  const a = document.createElement('a');
                  const url = window.URL.createObjectURL(blob);
                  a.href = url;
                  a.download = filename;
                  a.click();
                  window.URL.revokeObjectURL(url);
                },
                error: (err) => {
                  console.error('Download failed', err);
                }
              });
        });
    }


}
